import { FC } from 'react';
import { Typography } from '@mui/material';

import { DspAudience as DspAudienceSource, DspAudienceSourceCategoryGroup } from '../../../../../types/DspAudience';
import DspAudienceSourceUtils from '../../../../../utils/DspAudienceSourceUtils';

interface CampaignAdGroupAudienceTargetingSummaryTextProps {
    items: DspAudienceSource[];
}

const CampaignAdGroupAudienceTargetingSummaryText: FC<CampaignAdGroupAudienceTargetingSummaryTextProps> = ({
    items,
}) => {
    const groups: DspAudienceSourceCategoryGroup[] = DspAudienceSourceUtils.toDspAudienceSourceCategoryGroups(items);

    const groupCount: number = groups.length;
    const itemCount: number = items.length;

    return (
        <Typography variant="subtitle2">
            <Typography component="span" variant="subtitle2" color="text.primary">
                {groupCount}
            </Typography>{' '}
            Audience Categories and{' '}
            <Typography component="span" variant="subtitle2" color="text.primary">
                {itemCount}
            </Typography>{' '}
            Audience Sources
        </Typography>
    );
};

export default CampaignAdGroupAudienceTargetingSummaryText;
